import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class AdminVendorApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.MANAGEMENT_VENDOR);
  }

  approveVendor(vendorId) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${vendorId}/approve/`,
      {},
    );
  }
}

export default new AdminVendorApi();
